import { CombinedObservation } from "@tellescope/tanstack-query";
import { useMemo } from "react";
import { VitalsInvalidateAction } from "./VitalsInvalidateAction";

export interface VitalsActionsCellProps {
  observation: CombinedObservation;
}

export const VitalsActionsCell = ({ observation }: VitalsActionsCellProps) => {
  const observationIds = useMemo(
    () => observation.measurements.map(({ observationId }) => observationId),
    [observation.measurements]
  );

  return (
    <div className="flex items-center gap-1 justify-end">
      <VitalsInvalidateAction observationIds={observationIds} />
    </div>
  );
};
